<template>
	<dms-wrapper ref="wrapper" :label="labelText" :show-label="!isHiddenLabel && showLabel" v-bind="{span, wrapp, validationRules, noLabelAlign}"
		:validation-property="validationPropertyCmp" :disabled="isDisabled">
		<el-autocomplete ref="input" v-model="searchValue" v-bind="{type}" :clearable="false" :trigger-on-focus="false" :fetch-suggestions="querySearchAsync"
			:placeholder="placeholderText" :title="titleText" :disabled="isDisabled" popper-class="remote-search-popper"
			@select="handleSelect" @input="inputEvent($event)">
			<template slot-scope="{ item }">
				<div class="value">
					<span>{{ item.cells[searchFieldIndex] }}</span>
					<!-- eslint-disable-next-line vue/no-v-html -->
					<span v-if="hasAdditionalInfo" class="value-additional" v-html="additionalInfo(item, cellNames)" />
				</div>
			</template>
		</el-autocomplete>
	</dms-wrapper>
</template>

<script>
import _ from 'lodash';
import { columnsToCamelCase, getColumnsRowMapObject } from '@/main/utils/table';
import { toDbFieldName } from '@/main/utils/stringHelper';

import DmsInput from './Input.vue';

export default DmsInput.extend({
	name: 'DmsInputRemoteSearch',
	props: {
		uppercase: { type: Boolean, default: true },
		dataFetch: { type: Function, required: true },
		schemaFetch: { type: Function, required: true },
		filter: { type: Object, default: Object },
		searchFieldName: { type: String, default: 'value' },
		searchColumnName: { type: String, default: null },
		queryLength: { type: Number, default: 2 },
		additionalInfo: { type: Function },
	},
	data() {
		return { timeout: null, columns: null };
	},
	computed: {
		searchDbFieldName() {
			return this.searchColumnName ? this.searchColumnName : toDbFieldName(this.searchFieldName);
		},
		searchFieldIndex() {
			return this.columns.find((item) => item.columnName === this.searchDbFieldName).columnId;
		},
		hasAdditionalInfo() {
			return this.additionalInfo !== undefined;
		},
		searchValue: {
			get() {
				return this.value === 'null' ? '' : this.value;
			},
			set(val) {
				this.$emit('update:value', String(val));
			},
		},
		cellNames() {
			const result = {};
			_.forEach(this.columns, (col) => {
				result[col.columnName] = Number(col.columnId);
			});
			return result;
		},
	},
	created() {
		this.schemaFetch().then(({ data }) => {
			this.columns = columnsToCamelCase(data.Columns);
		});
	},
	methods: {
		querySearchAsync(queryString, cb) {
			clearTimeout(this.timeout);
			if (!queryString || queryString.length < this.queryLength) {
				this.$emit('clear');
				cb([]);
				return;
			}
			this.timeout = setTimeout(() => {
				const filterSearch = { ...this.filter, [this.searchFieldName]: queryString };
				this.apiQuery(filterSearch, cb);
			}, 2000);
		},
		handleSelect(item) {
			const mapedRow = getColumnsRowMapObject(this.columns, item.cells);
			this.searchValue = mapedRow[this.searchDbFieldName];
			this.$emit('selected', { row: mapedRow });
		},
		inputEvent(event) {
			this.$emit('update:value', event);
		},
		apiQuery(filterSearch, cb) {
			this.dataFetch(filterSearch)
				.then((resp) => {
					if (this.columns && resp.data.length === 1) {
						const mapedRow = getColumnsRowMapObject(this.columns, resp.data[0].Cells);
						this.searchValue = mapedRow[this.searchDbFieldName];
						this.$emit('selected', { row: mapedRow });
					} else {
						this.$emit('clear');
					}
					cb(columnsToCamelCase(resp.data).splice(0, 10));
				})
				.catch(() => {
					cb([]);
				});
		},
	},
});
</script>

<style scoped lang="scss">
	.value {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-end;
		flex-wrap: nowrap;

		&-additional {
			color: $color-notice-gray;
			font-size: 11px;
			padding-left: 15px;
			line-height: 31px;
		}
	}
</style>
